import Axios from "axios";
import {
  TICKET_SYSTEM_BASE_URL,
  TICKET_SYSTEM_UI_BASE_URL,
} from "../Constants/Constants";
import { JWT_TOKEN } from "../Constants/StorageConstants";
import { useAlert } from "./../components/alerts/AlertContext";

let licenseExpiredAlertShown = false;

const AxiosInstance = Axios.create({
  //baseURL: TICKET_SYSTEM_BASE_URL, //should enable in local
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  timeout: 10000,
});

AxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(JWT_TOKEN);
    //config.headers["Access-Control-Allow-Origin"] = TICKET_SYSTEM_UI_BASE_URL;
    config.headers["Access-Control-Allow-Origin"] = "*"
    config.headers["Access-Control-Allow-Methods"] = "GET,POST,PUT,DELETE,OPTIONS";
    config.headers["X-CLIENT-TYPE"] = "INTERNAL";

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
      if (config.data) {
        config.data = convertDatesToUTC(config.data);
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
AxiosInstance.interceptors.response.use(
  (response) => {
    // 1. Check if the backend response structure uses an envelope like response.data.data
    if (response?.data && response?.data?.data) {
      handleDates(response.data.data);
    } else if (response?.data) {
      // 2. Fallback if the response array/object is directly inside response.data
      handleDates(response?.data);
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 460) {
      //const showAlert = useAlert();
      if (!licenseExpiredAlertShown) {
        licenseExpiredAlertShown = true;
        alert("Your license has expired. Please update your license to continue using the application.");
      }

      //return Promise.reject("LICENSE_EXPIRED");  
      // Optional: Redirect to license upload screen
      //window.location.href = "/license";
      return new Promise(() => { });

    }
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(JWT_TOKEN);
      //window.location.href = "/login";
      console.error("Unauthorized! Redirecting to login...");
    }
    return Promise.reject(error);
  }
);

// Regular expression to match ISO UTC date strings
const isoUtcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

function handleDates(body) {
  if (body === null || body === undefined) return;

  if (typeof body === 'object') {
    for (const key of Object.keys(body)) {
      const value = body[key];

      if (typeof value === 'string' && isoUtcRegex.test(value)) {
        const date = new Date(value);

        // Convert UTC to local ISO-like string (without Z)
        body[key] = date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0') + 'T' +
          String(date.getHours()).padStart(2, '0') + ':' +
          String(date.getMinutes()).padStart(2, '0') + ':' +
          String(date.getSeconds()).padStart(2, '0');
      } else if (typeof value === 'object') {
        handleDates(value);
      }
    }
  }
}

const isDateString = (value) => {
  return (
    typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)
  );
};

const convertDatesToUTC = (obj) => {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map(convertDatesToUTC);
  }

  if (typeof obj === "object") {
    Object.keys(obj).forEach((key) => {
      obj[key] = convertDatesToUTC(obj[key]);
    });
    return obj;
  }

  if (isDateString(obj)) {
    // Treat local datetime as user's local timezone and convert to UTC
    return new Date(obj).toISOString();
  }

  return obj;
};

export default AxiosInstance;
